var scope_0 = require('/home/shinichi-kato/muno-site-scratch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bc98d80b0a7c4daffd716d72e542ac32.js').default;
var scope_1 = require('/home/shinichi-kato/muno-site-scratch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    